export const equipmentsQueryKeys = {
  all: ["equipments"] as const,
  lists: () => [...equipmentsQueryKeys.all, "lists"] as const,
  details: () => [...equipmentsQueryKeys.all, "details"] as const,
  detail: (equipmentId: string) =>
    [...equipmentsQueryKeys.details(), equipmentId] as const,
};

export const eventEquipmentRequestQueryKeys = {
  all: ["event-equipment-request"] as const,
  lists: () => [...eventEquipmentRequestQueryKeys.all, "lists"] as const,
  list: (eventId: string) =>
    [...eventEquipmentRequestQueryKeys.lists(), eventId] as const,
  details: () => [...eventEquipmentRequestQueryKeys.all, "details"] as const,
  detail: (eventId: string, equipmentRequestId: string) =>
    [
      ...eventEquipmentRequestQueryKeys.details(),
      equipmentRequestId,
      eventId,
    ] as const,
};
